define('models/composer/forms/FormType',{
        evaluation: 'evaluation',
        survey: 'survey'
});
